/* Wishlist Star → Wishlist Hero bridge */
document.addEventListener('click', function(e) {
  var star = e.target.closest('[data-wishlist-star]');
  if (!star) return;
  e.preventDefault();
  e.stopPropagation();
  
  /* Find the hidden WLH trigger next to the star */
  var wlhTrigger = star.parentElement.querySelector('.product-card__wlh-hidden');
  if (wlhTrigger) {
    /* Make it temporarily clickable */
    wlhTrigger.style.pointerEvents = 'auto';
    wlhTrigger.style.position = 'relative';
    wlhTrigger.click();
    /* Hide it again */
    setTimeout(function() {
      wlhTrigger.style.pointerEvents = 'none';
      wlhTrigger.style.position = 'absolute';
    }, 100);
  }
  
  /* Toggle star fill */
  var isActive = star.getAttribute('data-active') === 'true';
  star.setAttribute('data-active', isActive ? 'false' : 'true');
});